module.exports = __webpack_public_path__ + "img/plaano01.6b688c74.png";